<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="tasks"/>&nbsp;Registrar tarea
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <sys-form :inputs="task_details"/>
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: $route.params.type, params: { id: $route.params.id } })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import tasksStatusService from '@/services/tasks_status'
import taskService from '@/services/tasks'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'TaskCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      task_details: {
        title: {
          name: 'Título',
          hint: 'Título',
          value: '',
          type: 'text',
          validate: 'required',
          size: 12
        },
        content: {
          name: 'Contenido',
          hint: 'Contenido',
          value: '',
          type: 'textarea',
          validate: 'required',
          size: 12
        },
        status_id: {
          name: 'Estatus',
          hint: 'Selecciona un Estatus',
          value: null,
          type: 'select',
          size: 12,
          validate: 'required',
          options: []
        }
      }
    }
  },

  created: function () {
    tasksStatusService.list().then(res => {
      this.task_details.status_id.options = res.map(status => {
        return {value: status.id, text: status.description}
      })
    })
  },

  methods: {
    saveForm () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const creatorId = this.$route.params.id
          const username = this.$store.getters.getUsername
          const req = {
            'prospect_id': { value: creatorId },
            'author': { value: username }
          }

          let taskInfo = { ...this.task_details, ...req }
          let body = this.processForm(taskInfo)
          let service = taskService.post(this.$route.params.type, body)
          console.log(body)
          this.sendForm(service).then(res => {
            this.$router.push({
              name: this.$route.params.type,
              params: { id: this.$route.params.id }
            })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tasks/TaskCreate.vue